import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BillsRepository } from '@data-layer/repositories';
import { ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';

@Component({
  selector: 'paypal-agreement-redirect',
  templateUrl: './paypal-agreement-redirect.component.html',
  styleUrls: ['./paypal-agreement-redirect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaypalAgreementRedirectComponent implements OnInit, OnDestroy {
  @Input() public returnUrl: string;
  @Input() public subscriptionId: number;

  public iframeUrl: string;

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private billsRepository: BillsRepository, private route: ActivatedRoute) {}

  public ngOnInit(): void {
    const params = this.route.snapshot.queryParams;
    const isApprovalTokenId = params.approval_token_id;
    const subscriptionIdParam = !!this.subscriptionId ? `&subscriptionId=${this.subscriptionId}` : '';

    if (isApprovalTokenId) {
      this.redirectToPayPal(isApprovalTokenId);
    } else {
      const queryParamSymbol = !!params && Object.keys(params).length ? '&' : '?';
      this.billsRepository
        .paypalSetupToken(
          `${this.returnUrl + queryParamSymbol}isApproved=true${subscriptionIdParam}`,
          `${this.returnUrl + queryParamSymbol}isCancelled=true`,
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe((response) => {
          const approvalSessionId = response.approvalSessionId;
          this.redirectToPayPal(approvalSessionId);
        });
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  private redirectToPayPal(approvalSessionId: string) {
    const redirectUrl = environment.paypalAgreementUrl.replace('{{approvalSessionId}}', approvalSessionId);
    setTimeout(() => {
      // added timeout to skip onbeforeunload confirm dialog
      window.open(redirectUrl, '_self');
    });
  }
}
